import styled, { CSSProp } from 'styled-components';
import { colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import { StapleTableCell } from '@insurancemenu/imenu-components-lib/dist/components';

export const SUBSCRIBER_TYPES_COLORS: Record<string, string> = {
  P: colors.green[300],
  S: colors.purple[300],
  D: colors.blue[300],
  DP: colors.purple[300],
};

export const MemberTypeTagStyled = styled.p<{ $memberType: string }>`
  background-color: ${({ $memberType }): CSSProp => SUBSCRIBER_TYPES_COLORS[$memberType] || colors.blue[300]};
  color: ${colors.neutral[900]};
  padding: 0.5rem 1rem;
  font-size: 1.4rem;
  margin: 0;
  border-radius: 15px;
  max-width: 12rem;
  text-align: center;
  line-height: 2rem;
`;

export const MoreDropdownCellStyled = styled(StapleTableCell)`
  text-align: right;
`;
